import { StaticImage } from 'gatsby-plugin-image';

import {
  CUSTOM_FORMULA_PRICE_PER_MONTH,
  FUTURE_PROOF_PRICE_PER_MONTH,
} from 'consts/copy';
import { PAGE_URLS } from 'consts/pageUrls';
import { PRODUCT_LINKS } from 'consts/products';

import type { SubsectionProps } from '../components';

export const RX_PRODUCTS_MODULE: SubsectionProps = {
  moduleName: 'rxProducts',
  title: 'Try prescription skincare',
  subtitle:
    'Personalized by a licensed dermatology provider using only clinically proven ingredients',
  ctaButtonText: 'Get your formula',
  accentImage: {
    image: {
      desktop: (
        <StaticImage
          src="../images/provider-desktop@2x.jpg"
          alt="A smiling nurse practitioner in a white labcoat sitting at a computer with a Curology sticker on it."
          layout="fixed"
          width={331}
        />
      ),
      mobile: (
        <StaticImage
          src="../images/provider-mobile@2x.jpg"
          alt="A smiling nurse practitioner in a white labcoat sitting at a computer with a Curology sticker on it."
          layout="fullWidth"
        />
      ),
    },
    name: 'Jhamillia Weekes-Bowers, NP',
  },
  productCards: [
    {
      linkType: PRODUCT_LINKS.internal,
      href: PAGE_URLS.products.customFormulaAcne,
      name: 'Custom Formula',
      tag: 'Rx',
      description: 'Daily Acne Clearing Treatment',
      price: CUSTOM_FORMULA_PRICE_PER_MONTH,
      image: (
        <StaticImage
          src="../images/custom-formula@2x.jpg"
          alt="A bottle of Curology's Custom Formula."
          objectFit="contain"
        />
      ),
    },
    {
      linkType: PRODUCT_LINKS.internal,
      href: PAGE_URLS.products.futureProofAntiAging,
      name: 'Future-Proof',
      tag: 'Rx',
      description: 'Custom Preventative Anti-Aging Treatment',
      price: FUTURE_PROOF_PRICE_PER_MONTH,
      image: (
        <StaticImage
          src="../images/future-proof@2x.jpg"
          alt="A bottle of Curology's Future-Proof."
          objectFit="contain"
        />
      ),
    },
  ],
};
